"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

var css = _interopRequireWildcard(require("./PromotionalCard.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const CardComponent = props => (0, _pragma.createFelaElement)(_.View, _extends({
  as: "button"
}, props));

const SubTitleComponent = props => (0, _pragma.createFelaElement)(_.View, _extends({
  alignItems: "center"
}, props));

const PromotionalCard = /*#__PURE__*/React.forwardRef(({
  fullBleed = true,
  image,
  onClick,
  size = 'large',
  subtitle,
  title,
  variant = 'tan',
  linkText = 'Learn More',
  fullWidth = false
}, ref) => {
  const textColor = variant === 'tan' ? undefined : 'text.3';
  const padding = size === 'large' ? ['xxlarge', 'xlarge'] : ['large', 'medium'];
  const interactive = !!onClick;
  return (0, _pragma.createFelaElement)(_.Card, {
    interactive: interactive,
    alignItems: "center",
    as: CardComponent,
    color: variant,
    css: css.root,
    cssProps: {
      size,
      interactive,
      fullWidth
    },
    justifyContent: "space-between",
    onClick: onClick,
    padding: padding,
    ref: ref,
    variant: "secondary"
  }, (0, _pragma.createFelaElement)(_.View, {
    css: css.wrapper,
    cssProps: {
      size
    },
    flexDirection: "column",
    gap: "medium"
  }, (0, _pragma.createFelaElement)(_.Text, {
    align: "left",
    color: textColor,
    children: title,
    variant: "heading3"
  }), (0, _pragma.createFelaElement)(_.Text, {
    align: "left",
    as: SubTitleComponent,
    color: textColor || 'text.link',
    variant: "metaBold"
  }, subtitle), (0, _pragma.createFelaElement)(_.Text, {
    align: "left",
    as: SubTitleComponent,
    color: textColor || 'text.link',
    variant: "metaBold"
  }, (0, _pragma.createFelaElement)(_.View, {
    as: "span",
    inline: true,
    margin: ['none', 'xsmall', 'none', 'none']
  }, linkText), (0, _pragma.createFelaElement)(_.ArrowRightIcon, {
    color: textColor || 'text.link'
  }))), image && (0, _pragma.createFelaElement)("img", {
    alt: "",
    "aria-hidden": true,
    css: css.image,
    cssProps: {
      fullBleed
    },
    src: image
  }));
});
PromotionalCard.displayName = 'PromotionalCard';
var _default = PromotionalCard;
exports.default = _default;
//# sourceMappingURL=PromotionalCard.js.map